import React, { useEffect } from 'react';
import {
  Container,
  Sponsor,
  Apoio,
  ApoioMini,
  SponsorGrid,
  ApoioGrid,
} from './styles';
import { ContainerWhite } from '../Home/styles';

const REALIZACAO = [
  {
    title: 'Porto Alegre Inquieta',
    image: '/assets/evento/patrocinadores/porto-inquieta.svg',
    url: '',
  },
  {
    title: 'Pacto Alegre',
    image: '/assets/evento/patrocinadores/pacto-alegre.svg',
    url: '',
  },
  {
    title: 'Aliança para Inovação',
    image: '/assets/evento/patrocinadores/inova-o.svg',
    url: '',
  },
];

const CORREALIZACAO = [
  {
    title: 'Fundação Empresa Escola de Engenharia',
    image: '/assets/evento/patrocinadores/feeng.png',
    url: '',
  },
  {
    title: 'Governo do Estado do Rio Grande do Sul',
    image: '/assets/evento/patrocinadores/gov-rs-v3.png',
    url: '',
  },
  {
    title: 'Prefeitura de Porto Alegre',
    image: '/assets/evento/patrocinadores/prefeitura.png',
    url: '',
  },
];

const PATROCINIO_MASTER = [
  {
    title: 'Sebrae',
    image: '/assets/evento/patrocinadores/sebrae.svg',
    url: '',
  },
  {
    title: 'Sulgás',
    image: '/assets/evento/patrocinadores/sulgas.svg',
    url: '',
  },
  {
    title: 'Empresas Randon',
    image: '/assets/evento/patrocinadores/randon.svg',
    url: '',
  },
];

const PATROCINIO = [
  {
    title: 'Warren',
    image: '/assets/evento/patrocinadores/warren.svg',
    url: '',
  },
  {
    title: 'Grupo Zaffari',
    image: '/assets/evento/patrocinadores/zaffari.svg',
    url: '',
  },
  {
    title: 'Unimed',
    image: '/assets/evento/patrocinadores/unimed2.png',
    url: '',
  },
  {
    title: 'Motormac',
    image: '/assets/evento/patrocinadores/motormac.png',
    url: '',
  },
  {
    title: 'Coca-Cola',
    image: '/assets/evento/patrocinadores/coca-cola.svg',
    url: '',
  },
  {
    title: 'Banrisul',
    image: '/assets/evento/patrocinadores/banrisul.svg',
    url: '',
  },
  {
    title: 'SAP',
    image: '/assets/evento/patrocinadores/sap.png',
    url: '',
  },
];

const APOIO2 = [
  {
    title: 'Uhuu',
    image: '/assets/evento/patrocinadores/uhuu.svg',
    url: '',
  },
  {
    title: 'Do It',
    image: '/assets/evento/patrocinadores/doit.svg',
    url: '',
  },
  {
    title: 'On2',
    image: '/assets/evento/patrocinadores/on2.svg',
    url: '',
  },
  {
    title: 'DEx01',
    image: '/assets/evento/patrocinadores/dex.svg',
    url: '',
  },
  {
    title: 'Eyxo',
    image: '/assets/evento/patrocinadores/eyxo.svg',
    url: '',
  },
  {
    title: 'Alright',
    image: '/assets/evento/patrocinadores/alright.png',
    url: '',
  },
  {
    title: 'Grupo RBS',
    image: '/assets/evento/patrocinadores/rbs.png',
    url: '',
  },
];

const APOIO = [
  {
    title: 'Uhuu',
    image: '/assets/evento/patrocinadores/uhuu.svg',
    url: '',
  },
  
  {
    title: 'Grupo RBS',
    image: '/assets/evento/patrocinadores/rbs.png',
    url: '',
  },
];

const FINANCIAMENTO = [
  {
    title: 'Pró-cultura RS',
    image: '/assets/evento/patrocinadores/procultura.svg',
    url: '',
  },
  {
    title: 'Governo do Estado do Rio Grande do Sul',
    image: '/assets/evento/patrocinadores/gov-rs-v3.png',
    url: '',
  },
];

export const sponsors = [
  <div>
    <h2>REALIZAÇÃO</h2>
    <ApoioGrid>
      {REALIZACAO.map(apoio => (
        <div className="borderedSponsor">
          <div>
            <Sponsor background={apoio.image} key={apoio.image} />
          </div>
          <h2>{apoio.title}</h2>
        </div>
      ))}
    </ApoioGrid>
  </div>,
  <div>
    <h2>CORREALIZAÇÃO</h2>
    <ApoioGrid>
      {CORREALIZACAO.map(apoio => (
        <div className="borderedSponsor">
          <div>
            <Sponsor background={apoio.image} key={apoio.image} />
          </div>
          <h2>{apoio.title}</h2>
        </div>
      ))}
    </ApoioGrid>
  </div>,
  <div>
    <h2>PATROCÍNIO MASTER</h2>
    <ApoioGrid>
      {PATROCINIO_MASTER.map(apoio => (
        <div className="borderedSponsor">
          <div>
            <Sponsor background={apoio.image} key={apoio.image} />
          </div>
          <h2>{apoio.title}</h2>
        </div>
      ))}
    </ApoioGrid>
  </div>,
  <div>
    <h2>PATROCÍNIO</h2>
    <ApoioGrid>
      {PATROCINIO.map(apoio => (
        <div className="borderedMiniSponsor">
          <div>
            <Sponsor background={apoio.image} key={apoio.image} />
          </div>
          <h2>{apoio.title}</h2>
        </div>
      ))}
    </ApoioGrid>
  </div>,
  <div>
    <h2>APOIO</h2>
    <ApoioGrid>
      {APOIO.map(apoio => (
        <div className="borderedMiniSponsor">
          <div>
            <Sponsor background={apoio.image} key={apoio.image} />
          </div>
          <h2>{apoio.title}</h2>
        </div>
      ))}
    </ApoioGrid>
  </div>,
  <div>
    <h2>FINANCIAMENTO</h2>
    <ApoioGrid>
      {FINANCIAMENTO.map(apoio => (
        <div className="borderedMiniSponsor">
          <div>
            <Sponsor background={apoio.image} key={apoio.image} />
          </div>
          <h2>{apoio.title}</h2>
        </div>
      ))}
    </ApoioGrid>
  </div>,
];

const FooterLayout: React.FC = ({ children }) => {
  return (
    <>
      <Container>
        <div>
          <h2>REALIZAÇÃO</h2>
          <ApoioGrid>
            {REALIZACAO.map(apoio => (
              <div className="borderedSponsor">
                <div>
                  <Sponsor background={apoio.image} key={apoio.image} />
                </div>
                <h2>{apoio.title}</h2>
              </div>
            ))}
          </ApoioGrid>
        </div>

        <div>
          <h2>CORREALIZAÇÃO</h2>
          <ApoioGrid>
            {CORREALIZACAO.map(apoio => (
              <div className="borderedSponsor">
                <div>
                  <Sponsor background={apoio.image} key={apoio.image} />
                </div>
                <h2>{apoio.title}</h2>
              </div>
            ))}
          </ApoioGrid>
        </div>

        <div>
          <h2>PATROCÍNIO MASTER</h2>
          <ApoioGrid>
            {PATROCINIO_MASTER.map(apoio => (
              <div className="borderedSponsor">
                <div>
                  <Sponsor background={apoio.image} key={apoio.image} />
                </div>
                <h2>{apoio.title}</h2>
              </div>
            ))}
          </ApoioGrid>
        </div>
        <div>
          <h2>PATROCÍNIO</h2>
          <ApoioGrid>
            {PATROCINIO.map(apoio => (
              <div className="borderedMiniSponsor">
                <div>
                  <Sponsor background={apoio.image} key={apoio.image} />
                </div>
                <h2>{apoio.title}</h2>
              </div>
            ))}
          </ApoioGrid>
        </div>
        <div>
          <h2>APOIO</h2>
          <ApoioGrid>
            {APOIO.map(apoio => (
              <div className="borderedMiniSponsor">
                <div>
                  <Sponsor background={apoio.image} key={apoio.image} />
                </div>
                <h2>{apoio.title}</h2>
              </div>
            ))}
          </ApoioGrid>
        </div>
        <div>
          <h2>FINANCIAMENTO</h2>
          <ApoioGrid>
            {FINANCIAMENTO.map(apoio => (
              <div className="borderedMiniSponsor">
                <div>
                  <Sponsor background={apoio.image} key={apoio.image} />
                </div>
                <h2>{apoio.title}</h2>
              </div>
            ))}
          </ApoioGrid>
        </div>
      </Container>
    </>
  );
};

export default FooterLayout;
